import { inject, Injectable } from '@angular/core'
import { PvtEstabelecimentoService } from '../../../_services/estabelecimento/estabelecimento.service'
import { map } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class ShopsService {
  private _shopsService = inject(PvtEstabelecimentoService)

  listShops() {
    return this._shopsService.getAllEstabelecimentos().pipe(
      map(response => {
        response.sort((a, b) => a.nome.localeCompare(b.nome))
        return response
      })
    )
  }

  getShop(shopId: string) {
    return this._shopsService.getEstabelecimento(shopId).pipe(map(response => response[0]))
  }

  updateShopSchedulingRequirements(shopId: string, schedulingRequirements: string) {
    return this._shopsService.updateSchedulingRequirements(shopId, schedulingRequirements)
  }
}
